// Partners section

(function($) { "use strict";

	var winWidth = $(window).width();

	if(winWidth >= 1001) {
	

		var container = $('.section-partners');
		
		// check page contains element
		if( container.length ) {
			
			gsap.registerPlugin(ScrollTrigger);

			// let sections = gsap.utils.toArray(".panels_wrap .panel");

			// let scrollTween = gsap.to(".panels_wrap", {
			// 	xPercent: -100,
			// 	x: () => window.innerWidth,
			// 	ease: "none",
			// 	scrollTrigger: {
			// 		trigger: ".panels_wrap",
			// 		start: "top top",
			// 		// end: () => "+=" + extraLongContainer.offsetWidth + "px",
			// 		end: "+=3500",
			// 		scrub: true,
			// 		// snap: 1 / (sections.length - 1),
			// 		pin: true,
			// 		invalidateOnRefresh: true,
			// 		anticipatePin: 1,
			// 		// markers: true,
			// 	}	
			// });


			ScrollTrigger.create({
				trigger: ".section-partners",
				toggleClass: {targets: ".section-partners", className: "pin-activated"},
                start: "top top", 
                end: "bottom bottom",
                pin: ".section-partners .left"
				// end: "left 50%",
				// markers: true,
			});

			ScrollTrigger.create({
				trigger: ".section-partners",
				toggleClass: {targets: ".section-partners", className: "pin-complete"},
				start: "bottom bottom",
				// end: "left 50%",
				// markers: true,
			});


			// $('.section-timeline .panel').not(':last').each(function(index) {
			// 	console.log('adding timeline panel', (index + 1));
			// 	$(this).addClass('panel-' + (index + 1));
			// 	ScrollTrigger.create({
			// 		trigger: ".panel-" + (index + 1),
			// 		toggleClass: {targets: "body", className: "step-" + (index + 1)},

			// 		start: "left -150px",
			// 		end: "right -151px",
			// 		// markers: true,
			// 		containerAnimation: scrollTween,
			// 	});
			// });



			// ScrollTrigger.create({
			// 	trigger: ".section-timeline",
			// 	toggleClass: {targets: "body", className: "timeline-complete"},
			// 	start: "100.05% bottom",
			// 	// end: "left 50%",
			// 	// markers: true,
			// });
	
		}

	}

	

})(jQuery);





// document.addEventListener("DOMContentLoaded", function() {

// 	const partnersSection = document.querySelector('.section-partners');

//     // Select the target element
//     const targetElement = document.querySelector('.partners__heading');

//     // Callback function to handle intersection
//     const handleIntersection = (entries, observer) => {
//         entries.forEach((entry) => {
//             // console.log('Entry:', entry);
//             // console.log('Is Intersecting:', entry.isIntersecting);
//             if (entry.isIntersecting) {
//                 // targetElement.classList.add('scrolled-into-viewport');
// 				partnersSection.classList.add('js-pinned');
//                 console.log('js-pinned');
//             } else {
//                 // targetElement.classList.remove('scrolled-into-viewport');
// 				partnersSection.classList.remove('js-pinned');
//                 console.log('js-UNPINNED');
//             }
//         });
//     };

//     // Options for the intersection observer
//     // const options2 = {
//     //     rootMargin: '-450px 0px 0px 0px', // Adjust the top margin to trigger the intersection
// 	// 	// threshold: 0.6, // Trigger when 10% of the element is visible in the viewport
//     // };

//     // Create an intersection observer instance
//     const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0% 0% -66% 0%'});
//     // const observer = new IntersectionObserver(handleIntersection, { threshold: 1 });

//     // Observe the target element
//     observer.observe(targetElement);

// });
